import React from 'react';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { LeadFormLayout } from 'Views/Page/Content/Templates/LeadPageTemplate/LeadFormLayout';

const metaOverrideSet = buildFacetDesignOverride();

export const LeadPageForm = () => {
  const { pageContentResource, setPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      layout={LeadFormLayout}
      metaOverrideSet={metaOverrideSet}
      resource={pageContentResource}
      onSubmit={(resp) => setPageContentCollection(resp)}
    />
  );
};
